import type { WishlistType } from 'src/typings/wishlist'

const getWishlistIndexById = (
  wishlist: WishlistType,
  wishlistArray: WishlistType[]
) => wishlistArray?.findIndex((list) => list.id === wishlist.id)

export default getWishlistIndexById
